import type { AppRedirect } from '#src/shared/routes';

// we went with a corgi-level redirect instead of nginx as this is less likely to be shared and can safely be removed later
export const REDIRECTS: readonly AppRedirect[] = [
	{
		path: '/login_or_join/redirected',
		buildUrl: ({ queryString }) => `/login_or_join${queryString}`,
		reason: 'deprecated-url',
	},
];
